<template lang="pug">
div
  Navbar
  Hero(title="Original Films", subtitle="Produced by FanFair")
  section.container
    .columns.is-centered.is-multiline
      .column.is-flex.is-narrow(v-for="film in films")
        .card.is-light
          .card-image
            iframe.youtube(width="560", height="315" :src="'https://www.youtube.com/embed/' + film.embed" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
          .card-content
            .content
              p.title.is-4 {{ film.title }}
              p.subtitle.is-5 {{ film.description }}
  Hero(title="Videos", subtitle="Additional video content")
  section.container
    .columns.is-centered.is-multiline
      .column.is-flex.is-narrow(v-for="video in videos")
        .card.is-light
          .card-image
            iframe.youtube(width="560", height="315" :src="'https://www.youtube.com/embed/' + video.embed" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
          .card-content
            .content
              p.title.is-4 {{ video.title }}
              p.subtitle.is-5 {{ video.description }}
  br
  br
  br
  Footer
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Hero from "@/components/Hero.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Video",

  components: {
    Navbar,
    Hero,
    Footer
  },

  data() {
    return {
      videos: [],
      films: []
    };
  },

  methods: {
    // Get YouTube video id
    getVideoID(url) {
      const match = url.match(/^.*v=(.+)$/);
      if (match) {
        return match[1];
      }
    },

    // Fetch videos from Prismic
    getVideos() {
      this.$prismic.client
        .query(this.$prismic.Predicates.at("document.type", "video"), {
          orderings: "[my.video.date desc]"
        })
        .then(response => {
          const results = response.results;
          this.videos = results.map(document => {
            return {
              title: document.data.title ? document.data.title[0].text : "",
              thumbnail: document.data.thumbnail,
              description:
                document.data.description !== undefined
                  ? document.data.description[0].text
                  : "",
              date: document.data.date,
              link: document.data.link ? document.data.link["url"] : "",
              embed: document.data.link
                ? this.getVideoID(document.data.link["url"])
                : ""
            };
          });
        });
    },

    // Fetch films from Prismic
    getFilms() {
      this.$prismic.client
        .query(this.$prismic.Predicates.at("document.type", "film"), {
          orderings: "[my.film.date desc]"
        })
        .then(response => {
          const results = response.results;
          this.films = results.map(document => {
            return {
              title: document.data.title ? document.data.title[0].text : "",
              thumbnail: document.data.thumbnail,
              description:
                document.data.description !== undefined
                  ? document.data.description[0].text
                  : "",
              date: document.data.date,
              link: document.data.link ? document.data.link["url"] : "",
              embed: document.data.link
                ? this.getVideoID(document.data.link["url"])
                : ""
            };
          });
        });
    }
  },

  created() {
    this.getVideos();
    this.getFilms();
  }
};
</script>

<style lang="scss" scoped>
.card {
  width: 640px;
}

.youtube {
  width: 640px;
  height: 360px;
}
</style>
